class AlertAction {
  constructor(
    id,
    type,
    metaData,
    isPrimaryAction,
    reminderInterval,
    maxReminders,
    quietTimeList,
    delay,
    notificationGroupIdList,
    repeatEnabled,
    templateId,
  ) {
    this.id = id;
    this.type = type;
    this.metaData = metaData;
    this.isPrimaryAction = isPrimaryAction;
    this.reminderInterval = reminderInterval;
    this.maxReminders = maxReminders;
    this.quietTimeList = quietTimeList;
    this.delay = delay;
    this.notificationGroupIdList = notificationGroupIdList;
    this.repeatEnabled = repeatEnabled;
    this.templateId = templateId;
  }

  setQuietTimeList(quietTimeList) {
    this.quietTimeList = quietTimeList;
  }

  addQuietTime(quietTime) {
    this.quietTimeList.push(quietTime);
  }

  setNotificationGroupIdList(notificationGroupIdList) {
    this.notificationGroupIdList = notificationGroupIdList;
  }

  get hasReminder() {
    return this.reminderInterval != null;
  }

  get hasMaxReminders() {
    return this.maxReminders != null;
  }

  get hasDelay() {
    return this.delay != null;
  }

  get getNotificationGroupIdList() {
    return this.notificationGroupIdList.length > 0;
  }
}
export default AlertAction;
